export default {"src":"/_next/static/media/watermelon.510331ec.svg","height":200,"width":200,"blurWidth":0,"blurHeight":0};